// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.
export const environment = {
  production: false,
  
  //url: "http://www.ssj-yamasei.com",
  //sysPath:"http://www.ssj-yamasei.com",
  //sysName:"YAMASEI THAI",

 url:"https://vp-starch.ssj.co.th",
 sysName:"VP STARCH",
 sysPath:"https://vp-starch.ssj.co.th",
  

 //url:"http://cs-ibqs.com",
 //sysName:"CS ENGINEERING AUTOPART",
 //sysPath:"http://cs-ibqs.com",

   //online
  //url:"http://ibqs-cs.com/",
  //sysName:"CS ENGINEERING AUTOPART CO,.LTD.",
  //sysPath:"http://ibqs-cs.com",

  //ดึงข้อมูลรายงาน
  dburl: "https://vp-starch.ssj.co.th",
  dburlr:"https://vp-starch.ssj.co.th",
  dburlpc:"https://vp-starch.ssj.co.th",
  dburlnodejs:"https://vp-starch.ssj.co.th",


  sysVersion:"1.6",
  sysVersionName:"Version 1.6",
  coppyright:"© Copyright 2019. All Rights Reserved.",
  //timeLoading:36000,
  timeLoading_3_m_sec:10800,
  timeLoading_5_m_sec:10800,
  timeLoading_10_m_sec:36000,
  timeLoading_20_m_sec:66000,

  timeLoading:416000,
  timeLoading_5_sec:416000,
  timeLoading_30_sec:416000,
  timeLoading_1_minute:416000,
  timeLoading_3_minute:216000,
  timeLoading_6_minute:416000,

  //report
  stock_date_start:'2015-01-01 8:00:00',
  time_work_start:'08:00:00',
  time_work_stop:'07:59:59',
  time_sale_start:"6:00:00",
  time_sale_stop:"5:59:59"
};


// WEBPACK FOOTER //
// /Users/bizqsoft/Documents/project/ibqs/ibqs-dip-2023-09-09/src/environments/environment.prod.ts